<template>
  <component :is="component" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useUserStore } from "@/store/user";
import PageLoader from "@/components/v2/page-loader";
import { defineAsyncComponent } from "vue";

defineOptions({
  name: "sitemap-page",
});

const userStore = useUserStore();
const isLoggedIn = computed(() => userStore.isLoggedIn);

const component = computed(() =>
  defineAsyncComponent({
    loader: () => (!isLoggedIn.value ? import("@/components/v2/sitemap/index.vue") : import("@/components/sitemap/index.vue")),
    loadingComponent: PageLoader,
    delay: 0,
  }),
);
</script>

<style lang="scss">
@import "./index";
</style>
